<template>
  <div id="system-banners-add">
    <ipub-model :title="params.id?'Edit Banner':'Add Banner'"
                width="900px"
                :visable="isVisable"
                @confirm="confirm"
                @cancel="cancel">
      <ipub-form ref="banner-add-form"
                 :model="params"
                 :rules="rules">
        <ipub-form-item prop="name"
                        label="Title (Suggested word count 30)">
          <ipub-editor :height="200"
                       placeholder="Enter highlight detail here"
                       v-model.trim="params.name" />
        </ipub-form-item>
        <ipub-form-item prop="picture">

          <div class="mar-b-10 ipub-p2 fw-bd relative"
               slot="label">
            Image Upload<font class="key-color">*</font>
            <ipub-tooltip placement="right"
                          class="mar-l-5">
              <div slot="title">
                Suggested size: 800 * 500px; Support .png / .jpg; File size should be less than 500K.
              </div>
              <ipub-icon type="iconInfo" />
            </ipub-tooltip>

          </div>

          <ipub-upload-cropper @change="handleUpload"
                               :canWidth="canWidth"
                               :canHeight="canHeight"
                               :size="500"
                               :domain="domain"
                               :imgUrl="params.picture" />
        </ipub-form-item>
        <ipub-form-item prop="linked"
                        label="Links">
          <ipub-radio-group class="mar-b-10"
                            v-model="params.linked"
                            @change="onLinkedChange"
                            _label="name"
                            :options="[{name:'Yes',value:true},{name:'No',value:false}]" />
          <ipub-input v-if="params.linked"
                      placeholder="Enter link here"
                      v-model.trim="params.linkAddress" />
          <ipub-editor v-else
                       placeholder="Enter highlight detail here"
                       :height="200"
                       v-model.trim="params.linkText" />
        </ipub-form-item>
      </ipub-form>
      <div slot="footer">
        <ipub-button plain
                     type="primary"
                     :style="{minWidth: '150px'}"
                     @click="cancel">Cancel</ipub-button>
        <ipub-button plain
                     v-if="!params.id"
                     type="primary"
                     :style="{minWidth: '150px'}"
                     @click="confirm(false)">Save & Preview</ipub-button>
        <ipub-button type="primary"
                     :style="{minWidth: '150px'}"
                     @click="confirm(true)">Publish</ipub-button>
      </div>
    </ipub-model>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getUploadConfig } from '@/utils/upload'
import banner from '@/api/banner'
import check from '@/utils/check'
export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      params: {
        linked: true,
      },
      rules: {},
      isCropper: false,
      canWidth: 800,
      canHeight: 500,
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      publisherId: 'getPublisherId',
      domain: 'getDomain',
      journalId: 'getJournalId'
    })
  },
  watch: {
    isVisable (val) {
      if (!val) {
        this.params = {
          linked: true,
        }
      }
    }
  },
  mounted () {
    this.getRules()
  },
  methods: {
    async getQuery (id) {
      this.params = await banner.query(id)
    },
    async handleUpload (files) {
      const file = files[0]
      const types = ['image/jpeg', 'image/png']
      const rightType = types.includes(file.type)
      if (!rightType) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].isWrongType
        })
        return false
      }
      const MS = 2
      const maxSize = file.size / 1024 / 1024 < MS
      if (!maxSize) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].notExceed + MS + 'MB'
        })
        return false
      }
      const url = await getUploadConfig(file, `${this.publisherId}/journal/${this.journalId}/banner`)

      if (url.includes('err:')) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].uploadFileFail
        })
        return false
      }

      this.$set(this.params, 'pictureName', file.name)
      this.$set(this.params, 'picture', url)
    },
    cancelCopper () {
      this.isCropper = false
    },
    uploadCropper () {
      this.isCropper = true
    },
    async confirm (val) {

      const flag = this.$refs['banner-add-form'].validate()
      if (flag) {
        if (this.params.linked) {
          if (!this.params.linkAddress || !check.website(this.params.linkAddress)) {
            this.$message.error({ title: 'Error', content: this.LANGUAGE[this.language].enterCorrent + 'Link' })
            return
          }
        } else {
          if (!this.params.linkText) {
            this.$message.error({ title: 'Error', content: 'The content of the Link is empty' })
            return
          }
        }
        const data = Object.assign(this.params, {
          released: val,
          journalId: this.journalId
        })
        if (this.params.id) {
          await banner.edit(this.params.id, data)
          this.$message.success({ title: 'Success', content: 'This Banner has been published!' })
        } else {
          await banner.add(data)
          if (val) {
            this.$message.success({ title: 'Success', content: 'This Banner has been published!' })
          } else {
            this.$message.success({ title: 'Success', content: 'This Banner has been saved!' })
          }
        }
        this.$emit('confirm', data)
      }
    },
    onLinkedChange () {
      this.params.linkAddress = ''
      this.params.linkText = ''
    },
    preview () {

    },
    cancel () {
      this.$emit('cancel')
    },
    getRules () {
      this.rules = {
        name: [
          {
            required: true,
            message:
              'Title' +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
        picture: [
          {
            required: true,
            message:
              'Image' +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
        linked: [
          {
            required: true,
            message:
              'Link' +
              this.LANGUAGE[this.language].noEmpty
          },
        ],
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#system-banners-add {
  .upload-content {
    height: 180px;
    width: 280px;
    background: $content_color;
    border: 1px solid $border_color;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}
</style>
